var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-slider"},[_c('div',{class:['slider-track', _vm.directionClass],style:(_vm.trackStyle)},_vm._l((_vm.duplicatedLogos),function(logo,index){return _c('div',{key:index,staticClass:"slide"},[_c('img',{attrs:{"src":logo,"alt":"Logo de marca"}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }